<template>
  <v-card
    class="rms_settings rounded-0 pt-5 pb-0"
    elevation="0"
    :color="$vuetify.theme.dark ? '#172233' : '#e8f1f8'"
  >
    <v-row>
      <v-col cols="12">
        <v-card-title class="px-4 pt-0">Current Settings</v-card-title>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="8">
        <span class="content">Min. Trading Duration (min)</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[0]?.value }}</span>
      </v-col>
      <v-col cols="8">
        <span class="content">Min Margin Level</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[1]?.value }}</span>
      </v-col>
      <v-col cols="8">
        <span class="content">Max Margin Level</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[2]?.value }}</span>
      </v-col>
      <v-col cols="8">
        <span class="content">Floating Profit Percentage</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[3]?.value }}</span>
      </v-col>
      <v-col cols="8">
        <span class="content">Credit Out Percentage</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[4]?.value }}</span>
      </v-col>
       <v-col cols="8">
        <span class="content">Low Balance Threshold</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[5]?.value }}</span>
      </v-col>
       <v-col cols="8">
        <span class="content">Trading Idle Days</span>
      </v-col>
      <v-col cols="4">
        <span class="sub-content">{{ rmssettings?.[6]?.value }}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { RMSSETTINGS__ACTIONS } from "@/store/action-types";

export default {
  computed: {
    ...mapState("rmssettings", ["rmssettings"]),
  },

  methods: {
    ...mapActions("rmssettings", [RMSSETTINGS__ACTIONS.RMSSETTINGS]),
  },

  async mounted() {
    await this[RMSSETTINGS__ACTIONS.RMSSETTINGS]();
  },
};
</script>
